import { Card, ImageWithFallback, OutlineButton, PrimaryButton, Quantity } from 'client/CommonComponents';
import placeholder from "../.././../../assets/images/Placeholder.svg";
import { formatPrice } from "utils";
import './Catalog.scss';
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import { isMaxLength } from 'utils';
import permissions, { isAuthorized } from 'client/utils/Permissions';


const CatalogItem=(props:any)=>{
  const Popupcontent = props?.Popupcontent;
  const hideDialog = props?.hideDialog;
  const isCatalogItemExist = props?.isCatalogItemExist
    return(
     (isCatalogItemExist) ?
      <div className='mt-3'>
       {props?.catalogItemDetails?.length > 0 ?
        <Card data-attribute="CatalogItem_Default_Card">  
            <div className="catalog-block my-0">
            <div>
              <p className="catelog-heading">MANAGED EQUIPMENT CATALOG</p>
                {!props.isEditRequestClick ? <div className="pull-right fullWidth mb-3">
                <PrimaryButton
                  text="Add"
                  className="addNewItem ms-2"
                  onClick={props.addNewItemClick}
                 data-attribute="CatalogItem_Default_Button" />            
              </div> :
              <div className="pull-right fullWidth mb-3">

                <div className='editTypeBtnBlock mt-0'> <PrimaryButton text='Update Request' onClick={props.updateItemClick} className='me-2' disabled={!isAuthorized(permissions.CreateEditCatalog)} data-attribute="CatalogItem_Default_Button_2"></PrimaryButton>   
                <OutlineButton text='Cancel Request' onClick={props.cancelEditRequestType} className='me-0'  disabled={!isAuthorized(permissions.CreateEditCatalog)} data-attribute="CatalogItem_Default_Button_3" /></div>
              </div>}
 

            </div>
             <div className="clearfix catelog-item-wrapper">
              {props.catalogItemDetails?.map((item: any, _index: any) => {
                return (
                  <div
                    key={_index}
                    onClick={() => props.handleCardClick(item)}
                    className={`catelog-card ${item?.isSelected ? "active" : ""
                      }`}
                  >
                    <div className="vehicledetail-section">
                      <div className="vehicle-image">
                        <ImageWithFallback src={item.imagePath} alt="vehicle" fallbackSrc={placeholder}  data-attribute="CatalogItem_Default_ImageWithFallback" />
                      </div>
                      <div className="vehicle-specification">
                        <p className="vehicle-model" title={item.description}>{item.description}</p>
                      </div>
                      <div className="design-ratings">
                        <div className="selected-card">
                          <span className="selected-catalog"></span>
                        </div>
                      </div>
                    </div>
                    <div className="vehicleprice-section">
                      <div className="price-section">
                        <p><b>Estimated Price (incl. tax & fees)</b></p>
                        <span><b>{item.price ? `$${formatPrice(item.price, 2)}` : "N/A"}</b></span>
                      </div>
                        <div className="monthy-expenses">
                          <Quantity
                             increment={(e:any)=>props.quantityIncrement(e,item)}
                             onChange={(e:any)=>props.quantityOnChange(e,item)}
                             onKeyPress={(e:any) => {isMaxLength(e,2)}}
                             disableFlg={item?.quantity > 1 ? (item?.isSelected && item?.isDisable) : true}
                             decrement={(e:any)=>props.quantityDecrement(e,item)} 
                             value={item?.quantity == undefined ? 1: item?.quantity}
                             disable={((item?.isSelected && item?.isDisable) || props.isEditRequestClick)}
                             disabledQuantity = {(item?.isSelected && item?.isDisable) || props.isEditRequestClick}
                           data-attribute="CatalogItem_Default_Quantity" />
                          <div className='validMessage'>{item?.quantityerror}</div>
                        </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {Popupcontent.isDialogVisible ? 
              <CancelConfirmationPopup
                hideDialog={!Popupcontent.isDialogVisible}
                onDismiss={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => Popupcontent.popupPrimarybtnOnclick()}
              /> : ""}
            </div>          
        </Card>  : null}      
        </div> : <div className='mt-3'>
          <Card data-attribute="CatalogItem_Default_Card_2"><div className='no-record-data'>No catalog item</div> </Card>
        </div>
    )
}
 export default CatalogItem;